import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { format } from "../../components/text-helper/text-helper";
import HighlightedText from "./HighlightedText";
import "./Search.scss";
import { Genre } from "../../types/Genre";

interface GenreSearchResultProps {
    index: number;
    searchText: string;
    genre: Genre;
}

const GenreSearchResult = (props: GenreSearchResultProps) => {    
    return (
        <Box component={Link}
            className="search-result"
            key={`$artist-${props.index}`}
            to={`/genres/${props.genre.id}`}
        >
            <HighlightedText searchText={props.searchText} term={format(props.genre.name)} />
        </Box>
    );
}

export default GenreSearchResult;